import {derived, writable} from "svelte/store";
import {isoDateNow} from "../../../../../lib/dates_times";
import {
    I_COMPANY,
    I_PERSON,
    I_PERSON_COMPANY,
    personAsObject,
    personCompanyFromObject,
    companyFromObject,
    companyAsObject,
    personFromObject,
    requestAsObject,
    requestFromObject,
    dealFromObject,
    dealAsObject,
    promotionFromObject,
    promotionAsObject,
    I_PROMOTION,
    getNullShortlistPerson,
    I_SHORTLIST_PEOPLE,
    LOG_MESSAGE_TYPE,
    OBJECT_TYPE, I_REQUEST, I_DEAL
} from "../../../../../lib/datatypes";
import {addRawPerson, people, updateRawPerson} from "./people";
import {companies, addRawCompany, updateRawCompany} from "./companies";
import {
    person_company,
    getPersonCompanyForPerson,
    addPersonCompaniesForPerson, updatePersonCompanies
} from "./person_company";
import {addRawRequest, requests, updateRawRequest} from "./requests";
import {deals, addRawDeal, updateRawDeal} from "./deals";
import {promotions, addRawPromotion, updateRawPromotion} from "./promotions";
import {inArray} from "../../../../../lib/utils";


let $people = null;
const a_unsubscribe = people.subscribe(val => $people = val);

let $companies = null;
const b_unsubscribe = companies.subscribe(val => $companies = val);

let $person_company = null;
const c_unsubscribe = person_company.subscribe(val => $person_company = val);

let $requests = null;
const e_unsubscribe = requests.subscribe(val => $requests = val);

let $deals = null;
const f_unsubscribe = deals.subscribe(val => $deals = val);

let $promotions = null;
const g_unsubscribe = promotions.subscribe(val => $promotions = val);



// -- App State --

export const app_state = writable({
    username: 'testaudio',
    selected_person_id: null,
    selected_company_id: null,
    selected_request_id: null,
    selected_deal_id: null,
    selected_promotion_id: null,
});
export const selectPerson = id => {
    app_state.update(app_state => {
        app_state.selected_person_id = id;
        return app_state;
    })
};
export const selectCompany = id => {
    app_state.update(app_state => {
        app_state.selected_company_id = id;
        return app_state;
    })
};
export const selectRequest = id => {
    app_state.update(app_state => {
        app_state.selected_request_id = id;
        return app_state;
    })
};
export const selectDeal = id => {
    app_state.update(app_state => {
        app_state.selected_deal_id = id;
        return app_state;
    })
};
export const selectPromotion = id => {
    app_state.update(app_state => {
        app_state.selected_promotion_id = id;
        return app_state;
    })
};

let $app_state = null;
const app_state_unsubscribe = app_state.subscribe(val => $app_state = val);

// -- People --

export const people_search_list = derived([people, person_company], ([$people, $person_company]) => {
    let result = [];
    let person, position_list, companies_list;
    for(let i = 0, n = $people.list.length; i < n; i++) {
        person = $people.list[i];
        position_list = getPersonCompanyForPerson(person[I_PERSON.ID]);
        companies_list = position_list.map(item => {
            return $companies.lookup[item[I_PERSON_COMPANY.ID_COMPANY]];
        });
        // concatenating all interesting strings, making all lowercase, and then removing spaces
        let search_str = `${person[I_PERSON.FIRST_NAME]}${person[I_PERSON.LAST_NAME]}${position_list.map(o => o[I_PERSON_COMPANY.POSITION]).join('')}${companies_list.map(o => o[I_COMPANY.NAME]).join('')}`.toLowerCase();
        result.push([search_str.replace(/\s+/g, ''), person[I_PERSON.ID]]);
    }
    // console.log(result);
    return result;
}, []);


// ..making a derived store that additional_people_info can use to only update when number of people changes, not random updates to names etc
const people_length = derived(people, $people => $people.list.length);
// @OPTIMISE this runs over every person, every time - would be more efficient to only update what changed, but that would require tracking that
// @BUG this won't change whenever the company details change as it's only derived from the people store
export const additional_people_info = derived([people_length, person_company], ([$people_length, $person_company]) => {
    console.log('..deriving additional_people_info');
    let result = {}, temp;
    $people.list.forEach(o => {
        temp = getPersonCompanyForPerson(o[I_PERSON.ID]);
        // ..not everyone has an associated position/company, so need to return an 'empty' result for that
        if(temp.length === 0) {
            result[o[I_PERSON.ID]] = [{
                id_person: o[I_PERSON.ID],
                id_company: '',
                position: '',
                company_name: ''
            }];
        }
        else {
            result[o[I_PERSON.ID]] = temp.map(pc => {
                return {
                    id_person: o[I_PERSON.ID],
                    id_company: pc[I_PERSON_COMPANY.ID_COMPANY],
                    position: pc[I_PERSON_COMPANY.POSITION],
                    company_name: $companies.lookup[pc[I_PERSON_COMPANY.ID_COMPANY]][I_COMPANY.NAME]
                };
            });
        }
    });
    console.log(`${$people.list.length} were processed`);
    return result;
}, {});


let $additional_people_info = null;
const d_unsubscribe = additional_people_info.subscribe(val => $additional_people_info = val);

export const displayPersonFromID = person_id => {
    let raw_person = $people.lookup[person_id];
    let positions = $additional_people_info[person_id];
    let result = personAsObject(raw_person);
    result.positions = positions;
    return result;
};

export const fullNameFromRawPerson = person_arr => `${person_arr[I_PERSON.FIRST_NAME]} ${person_arr[I_PERSON.LAST_NAME]}`;
export const firstNameFromRawPerson = person_arr => `${person_arr[I_PERSON.FIRST_NAME]}`;
export const lastNameFromRawPerson = person_arr => `${person_arr[I_PERSON.LAST_NAME]}`;

export const addPerson = async display_person => {
    const person_arr = personFromObject(display_person);
    let person_company_arr_list = display_person.positions.map(personCompanyFromObject);
    let saved_person_arr = await addRawPerson(person_arr);
    // @ASSUMPTION - there is only 1/or the first person_company in the list will be the 'empty' one if person entered without a position or company
    if(person_company_arr_list[0][I_PERSON_COMPANY.ID_COMPANY] !== '') {
        // console.log(`saving a person_company because a company id is present`);
        let saved_person_company_arr_list = await addPersonCompaniesForPerson(saved_person_arr[I_PERSON.ID], person_company_arr_list);
    }
    // Logging the fact that a person has been created
    await logPersonCreated($app_state.username, saved_person_arr[I_PERSON.ID]);
    return saved_person_arr;
};

export const updatePerson = async display_person => {
    const person_arr = personFromObject(display_person);
    let person_company_arr_list = display_person.positions.map(personCompanyFromObject);
    let saved_person_arr = await updateRawPerson(person_arr);
    // @ASSUMPTION - there is only 1/or the first person_company in the list will be the 'empty' one if person entered without a position or company
    if(person_company_arr_list[0][I_PERSON_COMPANY.ID_COMPANY] !== '') {
        // console.log(`updating a person_company because a company id is present`);
        let saved_person_company_arr_list = await updatePersonCompanies(display_person.id, person_company_arr_list);
    }
    return saved_person_arr;
};

export const bucketPeopleBySurname = (people) => {
    // console.log(people);
    let person_buckets = {};
    let person, letter;
    for (let i = 0, n = people.length; i < n; i++) {
        person = people[i];
        letter = person[I_PERSON.LAST_NAME][0].toLowerCase();
        // letter = person.last_name.toLowerCase();
        switch (letter) {
            case 'a':
            case 'b':
            case 'c':
            case 'd':
            case 'e':
            case 'f':
            case 'g':
            case 'h':
            case 'i':
            case 'j':
            case 'k':
            case 'l':
            case 'm':
            case 'n':
            case 'o':
            case 'p':
            case 'q':
            case 'r':
            case 's':
            case 't':
            case 'u':
            case 'v':
            case 'w':
                if (person_buckets[letter] === undefined) person_buckets[letter] = [];
                person_buckets[letter].push(person);
                break;
            case 'x':
            case 'y':
            case 'z':
                if (person_buckets['xyz'] === undefined) person_buckets['xyz'] = [];
                person_buckets['xyz'].push(person);
                break;
            default:
                if (person_buckets['other'] === undefined) person_buckets['other'] = [];
                person_buckets['other'].push(person);
        }
    }
    return person_buckets;
}


// -- Companies --

export const company_search_list = derived(companies, $companies => {
    let result = [];
    let item;
    for(let i = 0, n = $companies.list.length; i < n; i++) {
        item = $companies.list[i];
        result.push([`${item[I_COMPANY.NAME]}`.toLowerCase().replace(/\s+/g, ''), item[I_COMPANY.ID]]);
    }
    return result;
}, []);

export const displayCompany = id => {
    return companyAsObject($companies.lookup[id]);
};

export const addCompany = async display_company => {
    const company_arr = companyFromObject(display_company);
    let saved_company_arr = await addRawCompany(company_arr);
    // Logging the fact that this company has been created
    await logCompanyCreated($app_state.username, saved_company_arr[I_COMPANY.ID]);
    return saved_company_arr;
};

export const updateCompany = async display_company => {
    const company_arr = companyFromObject(display_company);
    let saved_company_arr = await updateRawCompany(company_arr);
    return saved_company_arr;
};



// -- Requests --

export const displayRequest = request_id => {
    return requestAsObject($requests.lookup[request_id]);
};

export const addRequest = async display_request => {
    display_request.created = isoDateNow();
    display_request.updated = isoDateNow();
    const request_arr = requestFromObject(display_request);
    let saved_request_arr = await addRawRequest(request_arr);
    // Logging that a request has been created
    await logRequestCreated($app_state.username, saved_request_arr[I_REQUEST.ID]);
    return saved_request_arr;
};

export const updateRequest = async display_request => {
    display_request.updated = isoDateNow();
    const request_arr = requestFromObject(display_request);
    let saved_request_arr = await updateRawRequest(request_arr);
    return saved_request_arr;
};


// -- Deals --

export const displayDeal = deal_id => {
    return dealAsObject($deals.lookup[deal_id]);
};

export const addDeal = async display_deal => {
    display_deal.created = isoDateNow();
    display_deal.updated = isoDateNow();
    const deal_arr = dealFromObject(display_deal);
    let saved_deal_arr = await addRawDeal(deal_arr);
    // Logging that a deal has been created
    await logDealCreated($app_state.username, saved_deal_arr[I_DEAL.ID]);
    return saved_deal_arr;
};

export const updateDeal = async display_deal => {
    display_deal.updated = isoDateNow();
    const deal_arr = dealFromObject(display_deal);
    let saved_deal_arr = await updateRawDeal(deal_arr);
    return saved_deal_arr;
};


// -- Promotions --

export const displayPromotion = promotion_id => {
    return promotionAsObject($promotions.lookup[promotion_id]);
};

export const addPromotion = async display_promotion => {
    display_promotion.created = isoDateNow();
    display_promotion.updated = isoDateNow();
    const promotion_arr = promotionFromObject(display_promotion);
    let saved_promotion_arr = await addRawPromotion(promotion_arr);

    // Now update the parent deal with the new promotion id
    let display_deal = displayDeal(display_promotion.id_deal);
    display_deal.list_promotions.push(saved_promotion_arr[I_PROMOTION.ID]);
    await updateDeal(display_deal);

    // Logging that a new promotion has been created
    await logPromotionCreated($app_state.username, saved_promotion_arr[I_PROMOTION.ID]);
    return saved_promotion_arr;
};

export const updatePromotion = async display_promotion => {
    display_promotion.updated = isoDateNow();
    const promotion_arr = promotionFromObject(display_promotion);
    let saved_promotion_arr = await updateRawPromotion(promotion_arr);
    return saved_promotion_arr;
};

export const addToShortlist = async (promotion_id, person_id) => {
    let promotion_arr = $promotions.lookup[promotion_id];
    let item = getNullShortlistPerson();
    item[I_SHORTLIST_PEOPLE.ID_PERSON] = person_id;
    promotion_arr[I_PROMOTION.LIST_SHORTLIST_PEOPLE].push(item);
    let saved_promotion_arr = await updateRawPromotion(promotion_arr);
    return saved_promotion_arr;
};
export const removeFromShortlist = async (promotion_id, person_id) => {
    let promotion_arr = $promotions.lookup[promotion_id];
    promotion_arr[I_PROMOTION.LIST_SHORTLIST_PEOPLE] = promotion_arr[I_PROMOTION.LIST_SHORTLIST_PEOPLE].filter(shortlist_person => {
        // NB deliberately allowing casting in comparison for the case where one type is Number and the other is string
        return shortlist_person[I_SHORTLIST_PEOPLE.ID_PERSON] != person_id;
    });
    let saved_promotion_arr = await updateRawPromotion(promotion_arr);
    return saved_promotion_arr;
};


// File Uploads

const createFileUploader = () => {
    const { subscribe, set, update } = writable({
        files: [],
        is_uploading: false,
    });
    let _el = null;
    return {
        subscribe,
        setDOMEl: (el) => {
            // console.log('DOM El', el);
            _el = el
        },
        chooseFiles: () => {
            _el.click();
        },
        markAsUploading: () => {
            update(o => {
                o.is_uploading = true;
                return o;
            });
        },
        serverResponse: files => update(o => {
            o.files = files;
            o.is_uploading = false;
            return o;
        }),
        resetFiles: () => update(o => {
            // console.log('resetting file array');
            o.files = [];
            return o;
        })
    };
};
export const filemanager = createFileUploader();


// Lightbox

export const lightbox_manager = writable({
    visible: false,
    img_url: 'https://tailwindui.com/img/ecommerce-images/product-page-01-featured-product-shot.jpg'
});
let $lightbox_manager = null;
const h_unsubscribe = lightbox_manager.subscribe(val => $lightbox_manager = val);
export const showLightBox = img_url => {
    lightbox_manager.update(lightbox_manager => {
        lightbox_manager.img_url = img_url;
        lightbox_manager.visible = true;
        return lightbox_manager;
    });

};
export const hideLightBox = () => {
    lightbox_manager.update(lightbox_manager => {
        lightbox_manager.visible = false;
        return lightbox_manager
    });
};


// Next Actions
export const NEXT_ACTION_STATES = {
    NEED_DETAILS: 0,
    WAITING_FOR: 1,
    ACTION_NEEDED: 2,
    NO_ACTION: 3,
};
export const DETAIL_MEANING_NO_ACTION_NEEDED = 'no action needed';
export const uiStateFromNextAction = next_action => {
    if(next_action.details === '') return NEXT_ACTION_STATES.NEED_DETAILS;
    else if(next_action.details === DETAIL_MEANING_NO_ACTION_NEEDED) return NEXT_ACTION_STATES.NO_ACTION;
    else if(next_action.waiting_for && next_action.details !== '') return NEXT_ACTION_STATES.WAITING_FOR;
    else return NEXT_ACTION_STATES.ACTION_NEEDED; // if(!next_action.waiting_for && next_action.details !== '')
};


// Logs

const handleSaveLog = async (username, owner_type, owner_id, log_message_type, log_data) => {
    if(!inArray(Object.values(LOG_MESSAGE_TYPE), log_message_type)) {
        throw new Error(`log_message_type not recognised: ${log_message_type}`);
    }
    const url = `/api/${owner_type}/${owner_id}/log`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            username: username,
            log_message_type: log_message_type,
            data: log_data
        })
    });
    let result = await response.json();
    // console.log(response, result);
    return result;
};
const logCreated = async (username, object_type, id) => await handleSaveLog(username, object_type, id, LOG_MESSAGE_TYPE.OBJECT_CREATED, '');
export const logPersonCreated = async (username, id) => {
    return await logCreated(username, OBJECT_TYPE.PERSON, id);
}
export const logCompanyCreated = async (username, id) => await logCreated(username, OBJECT_TYPE.COMPANY, id);
export const logRequestCreated = async (username, id) => await logCreated(username, OBJECT_TYPE.REQUEST, id);
export const logDealCreated = async (username, id) => await logCreated(username, OBJECT_TYPE.DEAL, id);
export const logPromotionCreated = async (username, id) => await logCreated(username, OBJECT_TYPE.PROMOTION, id);

export const logPersonContacted = async (username, object_type, id, data) => await handleSaveLog(username, object_type, id, LOG_MESSAGE_TYPE.CONTACTED, data);
export const logActionCompleted = async (username, object_type, id, data) => await handleSaveLog(username, object_type, id, LOG_MESSAGE_TYPE.ACTION_COMPLETED, data);
export const logUserEntry = async (username, object_type, id, data) => await handleSaveLog(username, object_type, id, LOG_MESSAGE_TYPE.USER_ENTRY, data);
